export default class MessageLogger {
	constructor(maxMessagesToStore, maxMessagesSent) {
		this.queue = [];
		this.maxMessagesToStore = maxMessagesToStore;
		this.maxMessagesSent = maxMessagesSent;
	}

	// Items are stored oldest-first (push to back). Entries may be strings or
	// zero-arg functions that produce a string — evaluated lazily so callers can
	// defer expensive work (JSON.stringify, Date.toISOString, etc.) until the dump
	// is actually read (i.e. only when a Sentry report is generated).
	get dump() {
		return this.queue
			.slice(-this.maxMessagesSent)
			.map(function(entry) { return typeof entry === 'function' ? entry() : entry; })
			.reverse();
	}

	get fullDump() {
		const evaluated = this.queue
			.slice()
			.reverse()
			.map(function(entry) { return typeof entry === 'function' ? entry() : entry; });
		return JSON && JSON.stringify ? JSON.stringify({ queue: evaluated }) : evaluated.join('\n');
	}

	// Accepts a string or a zero-arg function (() => string).
	// push() is O(1) vs the previous unshift() which was O(n) on every log call.
	// shift() at capacity is O(n) but only fires once per overflow event.
	logMessage(message) {
		this.queue.push(message);

		if (this.queue.length > this.maxMessagesToStore) {
			this.queue.shift();
		}
	}
}
